import React from "react";
import { Link } from "react-router-dom";

export default function FlyerOptionsHeader() {
  return (
    <div className="relative">
      <Link to="/select-flyer" className="">
        <button
          type="button"
          className="absolute right-6 top-4 px-4 py-2 border border-gray-300 rounded-md shadow-sm text-md font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-complimentary"
        >
          Go To All Flyers
        </button>
      </Link>
      <div className="pt-12 md:pt-6">
        <h1 className="ml-4 text-blue-primary text-3xl font-semibold">
          Flyer Options
        </h1>
        <p className="text-gray-600 text-lg">
          Select your options below. Click download to download your flyer or
          click preview to see your flyer in action.
        </p>
      </div>
    </div>
  );
}
